import { useEffect, useMemo, useState } from 'react';

import useJapaneseRegionalSite from '../experiments/useJapaneseRegionalSite';

export enum ImageExperience {
  JAPANESE = 'japanese',
  JADE = 'jade',
  DEFAULT = 'default',
}

interface ImageExperienceProps {
  japaneseImgObj?: { img: string; alt: string };
  jadeImgObj: { img: string; alt: string };
  defaultImgObj: { img: string; alt: string };
}

export const useImageExperience = ({
  japaneseImgObj,
  jadeImgObj,
  defaultImgObj,
}: ImageExperienceProps): { img: string; alt: string } => {
  const isJapaneseRegionalSite = useJapaneseRegionalSite();
  const [img, setImg] = useState(defaultImgObj);

  const experience = useMemo(() => {
    if (isJapaneseRegionalSite) {
      return ImageExperience.JAPANESE;
    } else {
      return ImageExperience.JADE;
    }
  }, [isJapaneseRegionalSite]);

  useEffect(() => {
    const next =
      experience === ImageExperience.JAPANESE && japaneseImgObj
        ? japaneseImgObj
        : jadeImgObj;
    setImg((prev) =>
      prev.img === next.img && prev.alt === next.alt ? prev : next,
    );
  }, [experience, jadeImgObj, japaneseImgObj]);

  return img;
};
